<template>
  <div>
    <HeaderTop :isBackgroundShow="isBackgroundShow"  page="home" :isBlack="true" homeTitle="搜索"></HeaderTop>
    <div class="search" @scroll="handleScroll">
      <div class="searchForm">
        <div class="searchInput">
          <Input placeholder="请输入关键字" v-model="searchNameData" @keyup.enter.native="toSearchNews">
            <!--        <Icon type="ios-search" slot="suffix" @click="toSearchNews" style="cursor: pointer" />-->
          </Input>
        </div>
        <img src="../assets/img/search.png"  style="cursor: pointer" @click="toSearchNews"/>
      </div>
      <div class="searchList">
        <ul>
          <li v-for="(list,index) in searchList" :key="index" v-if="searchList.length>0" @click="toNewDetail(list)"
            style="cursor: pointer;">
            <div class="searchTitle">
              <span v-html="brightenKeyword(list.title, searchNewNameData)"></span>
            </div>
            <div class="searchDate">{{list.createtime}}</div>
<!--            <div class="searchDesc" v-html="brightenKeyword(list.content, searchNewNameData)"></div>-->
          </li>
        </ul>
      </div>
      <div class="page" v-if="searchList.length>0">
        <Pagination ref="pagination" v-on:pageChange="pageChange($event)" :current="pageNum" :pageSize="pageSize"
                    :total="total" @toPageFirst="toPageFirst" @toPageLast="toPageLast"></Pagination>
      </div>
    </div>
    <float-element :showTop="showTop"></float-element>
    <Bottom></Bottom>
  </div>
</template>

<script>
  import HeaderTop from "@/components/headerTop"
  import Bottom from "@/components/bottom"
  import Pagination from '@/components/pagination';
  import FloatElement from "@/components/floatElement";

  export default {
    name: "searchList",
    components: {
      HeaderTop,
      Bottom,
      Pagination,
      FloatElement
    },
    data() {
      return {
        firstSearch: '',
        searchNameData: '',
        searchNewNameData: '',
        bannerShow: false,
        pageNum: 1,
        pageSize: 10,
        total: 0,
        searchList: [],
        isBackgroundShow: true,
        showTop: false
      }
    },
    watch: {
      '$route': {
        handler(route) {
          const that = this
          if (route.name === 'searchList') {
            that.getInfo()
          }
        },
        deep: true
      }
    },
    created() {
      this.searchNameData = this.$route.query.searchKey
      this.getInfo()
    },
    destroyed() {
      sessionStorage.removeItem("detail");
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll); // 移除滚动事件监听器
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll); // 添加滚动事件监听器
      this.getSchoolWebModuleMessageListFunc();
    },
    methods: {
      // 末页
      toPageLast() {
        this.pageNum = Math.ceil(this.total / this.pageSize);
        console.log('pageNum==', this.pageNum)
        this.toSearchNews('page')
      },
      toPageFirst() {
        this.pageNum = 1
        this.toSearchNews('page')
      },
      handleScroll(event) {
        const scrollTop = window.scrollY; // 获取滚动条相对于文档顶部的距离
        // 产品中心
        if (scrollTop >= 10) {
          this.isBackgroundShow = true
          this.showTop = true
        } else {
          this.isBackgroundShow = false
          this.showTop = false
        }
      },
      // 保留分页
      getSchoolWebModuleMessageListFunc() {
        if (sessionStorage.getItem('detail')) {
          this.pageNum = Number(sessionStorage.getItem("currentPage"));
        } else {
          this.pageNum = 1;
          sessionStorage.removeItem("currentPage");
        }
      },
      //新闻详情
      toNewDetail(data, name) {
        this.$router.push({
          path: '/InformationDynamicsDetail',
          query: {
            id: data.id
          }
        })
      },
      getInfo() {
        if (this.$route.query.searchKey == undefined) {
          this.searchNameData = sessionStorage.getItem("searchNameData")
        } else {
          sessionStorage.setItem("searchNameData", this.$route.query.searchKey)
          this.searchNameData = this.$route.query.searchKey
        }
        this.toSearchNews()
      },
      toSearch(searchName) {
        this.searchNameData = searchName
        this.toSearchNews()
      },
      toSearchNews(type) {
        if(this.firstSearch !== this.searchNameData || type == 'page') {
          sessionStorage.setItem("searchNameData", this.searchNameData)
          this.searchNewNameData = this.searchNameData
          this.$API.InterfaceConfigurationPage
            ._toSearch({
              params: {
                keyword: this.searchNameData,
                pageindex: this.pageNum,
                pagesize: this.pageSize
              }
            })
            .then(res => {
              if (res.success) {
                if (res.data == '[]') {
                  this.searchList = []
                } else {
                  this.searchList = res.data
                }
                this.total = res.totalcount
              } else {
                this.$Message.info('系统错误')
              }
              this.firstSearch = this.searchNameData
            })
            .catch(err => {
              console.log('获取失败===', err);
              this.firstSearch = this.searchNameData
            });
        }
      },
      //翻页
      pageChange(page) {
        sessionStorage.setItem('currentPage', page);
        this.pageNum = page
        this.toSearchNews('page')
      },
      //关键字变色
      brightenKeyword(val, keyword) {
        val = val + '';
        if (val.indexOf(keyword) !== -1 && keyword !== '') {
          return val.replace(keyword, '<font color="#5280B6">' + keyword + '</font>')
        } else {
          return val
        }
      }
    }
  }

</script>

<style scoped lang="less">
  @import "../assets/css/search.less";

</style>



// WEBPACK FOOTER //
// src/views/searchList.vue